// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_2dXF8","hidden":"_1uG4K","title":"_2k-os","link":"_1ea1m"};